import { gql } from '@apollo/client';
import { ProductInfo } from '../fragments';

export default gql`
  query product($id: ID) {
    product(id: $id) {
      ...ProductInfo
    }
  }
  ${ProductInfo}
`;
